import { Injectable } from '@angular/core';
import { BehaviorSubject, Subscription, timer } from 'rxjs';

// If a key is added here, an equivalent key must be added to the translation file
export enum ErrorKey {
  inactiveUser = 'inactiveUser',
  networkError = 'network',
  neighbourhood = 'neighbourhood',
  lead = 'lead',
  cms = 'cms',
};

// {"statusCode":401,"errorCode":41010,"errorMessage":"IDP_INVALID_REFRESH_TOKEN","message":"Refresh token invalid","requestId":"b2b0622a4593490c980ba6bf0001ec02"}
export interface DisplayError {
  msgKey: string;
  code?: number;
}

interface ErrorMap {
  [errorKey: string]: {
    code?: number;
    timerSub?: Subscription;
  }
}

@Injectable()
export class ErrorService {

  private readonly _currentErrorMap: ErrorMap = {};
  private readonly _allErrorsSubject = new BehaviorSubject<DisplayError[]>([]);

  public readonly allErrors = this._allErrorsSubject.asObservable();

  private _emitMapAsArray() {
    let arr = Object.keys(this._currentErrorMap).map(key => ({
      msgKey: key,
      code: this._currentErrorMap[key].code
    }));

    this._allErrorsSubject.next(arr);
  }

  private _clearAfter(errorKey: ErrorKey, seconds: number): Subscription {
    return timer(seconds * 1000).subscribe(() => {
      delete this._currentErrorMap[errorKey];
      this._emitMapAsArray();
    });
  }

  public clearError(errorKey: ErrorKey, emit = true) {
    if (this._currentErrorMap[errorKey] && this._currentErrorMap[errorKey].timerSub) {
      this._currentErrorMap[errorKey].timerSub.unsubscribe();
    }
    delete this._currentErrorMap[errorKey];
    if (emit) this._emitMapAsArray();
  }

  public clearAllErrors() {
    Object.keys(this._currentErrorMap).forEach(key => this.clearError(<ErrorKey>key, false));
    this._emitMapAsArray();
  }

  /**
   * @param errorKey error translation key
   * @param code any error code that might be returned from server to give extra context.
   * @param secondsToDisplay clear this error from screen after X seconds
   */
  public displayError(errorKey: ErrorKey, code?: number, secondsToDisplay?: number) {
    if (!this._currentErrorMap[errorKey]) {
      this._currentErrorMap[errorKey] = { code: code };
      if (secondsToDisplay) this._currentErrorMap[errorKey].timerSub = this._clearAfter(errorKey, secondsToDisplay);
    } else if (this._currentErrorMap[errorKey].timerSub && secondsToDisplay) {
      this._currentErrorMap[errorKey].timerSub.unsubscribe();
      this._currentErrorMap[errorKey].timerSub = this._clearAfter(errorKey, secondsToDisplay);
    }
    this._emitMapAsArray();
  }

}
